import axios from "axios"

export const getIPAddresses = async (params = {}) => {
  return await axios.get("/controls/ipadress/", { params })
}

export const createIPAdress = async (payload = {}) => {
  return await axios.post(`/controls/ipadress/`, payload)
}

export const deleteIPAdress = async id => {
  return await axios.delete(`/controls/ipadress/${id}/`)
}

export const updateIPAdress = async payload => {
  const { id, data } = payload
  return await axios.patch(`/controls/ipadress/${id}/`, data)
}
